module.exports = __webpack_public_path__ + "6d3cc6875960d37f9e494657caba2670.jpg";